// Generated by GitHub Copilot
import { motion } from "framer-motion";

const FALLBACK_PARAGRAPHS = [
    "Most people online know me as dragon. I build AI and ML products with a focus on reliable delivery, practical impact, and close collaboration.",
];

/**
 * Render the dedicated about page narrative.
 *
 * @param {{ config?: { title?: string, paragraphs?: string[] } }} props Component props.
 * @returns {JSX.Element} About page section.
 */
function AboutPage({ config }) {
    const title = config?.title || "About Me";
    const paragraphs = Array.isArray(config?.paragraphs) && config.paragraphs.length
        ? config.paragraphs
        : FALLBACK_PARAGRAPHS;

    return (
        <section className="py-16" id="about-page">
            <motion.div
                className="glass-card-strong mx-auto max-w-4xl rounded-3xl p-6 md:p-8"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
            >
                <h1 className="text-2xl font-semibold tracking-tight text-[var(--text-primary)] md:text-3xl">{title}</h1>

                <div className="mt-4 space-y-4 text-sm leading-relaxed text-[var(--text-secondary)] md:text-base">
                    {paragraphs.map((paragraph, index) => (
                        <p key={`${index}-${title}`}>{paragraph}</p>
                    ))}
                </div>
            </motion.div>
        </section>
    );
}

export default AboutPage;
